@let financialAccount = financialAccount$ | async;
@let loadFinancialAccount = loadFinancialAccount$ | async;
@let transactionLimits = transactionLimits$ | async;

@if (!financialAccount) {
  <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL()" />

  <app-details-page-content-placeholder [singleColumn]="true" />
} @else {
  <app-details-page-header
    [pageReturnURL]="pageReturnURL()"
    [title]="financialAccount.displayName"
    [status]="financialAccount.state"
    [breadcrumbs]="breadcrumbs()"
  >
    <div class="flex items-center">
      <button
        appRemoveFocus
        class="p-2 text-2xl text-secondary rounded-full transition-colors hover:bg-white"
        (click)="onActionBtnClick(financialAccount.state)"
        title="{{ financialAccount.state === 'SUSPENDED' ? 'Unsuspend' : 'Suspend' }}"
        [disabled]="financialAccount.state !== 'ACTIVE' && financialAccount.state !== 'SUSPENDED'"
      >
        <rkt-icon name="{{ financialAccount.state === 'SUSPENDED' ? 'resume' : 'suspend' }}" />
      </button>
      <button
        appRemoveFocus
        class="p-2 text-2xl text-secondary rounded-full transition-colors hover:bg-white"
        (click)="onEditBtnClick(financialAccount)"
        title="Edit Financial Account"
        [disabled]="financialAccount.state !== 'ACTIVE' && financialAccount.state !== 'SUSPENDED'"
      >
        <rkt-icon name="edit" />
      </button>
    </div>
  </app-details-page-header>

  <div class="flex gap-5 mt-5">
    <div class="flex-1">
      <app-financial-account-balances
        [noBottomOffset]="true"
        [isLoading]="false"
        [accountBalanceValues]="financialAccount.accountBalances"
        [selectedCurrency]="financialAccount.currency"
        [isFullWidth]="financialAccount.category === 'EXTERNAL'"
      />
    </div>

    @if (financialAccount.category !== 'EXTERNAL') {
      <div class="bg-white rounded-lg px-6 py-5 flex-1">
        <app-transaction-limits
          [transactionLimits]="transactionLimits ?? []"
          (editClick)="onEditTransactionLimitsClick(financialAccount.id, transactionLimits, financialAccount.currency)"
        />
      </div>
    }
  </div>

  <ul class="tab-nav-items mt-4">
    @for (tab of tabItems(); track $index) {
      <li class="tab-nav-item">
        @if (isActive(tab.href)) {
          <a class="tab-nav-link active">{{ tab.tabName }}</a>
        } @else {
          <a [routerLink]="tab.href" class="tab-nav-link">{{ tab.tabName }}</a>
        }
      </li>
    }
  </ul>

  <router-outlet />
}
